/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentPlan from './treatment-plan';
import TreatmentPlanDetail from './treatment-plan-detail';
import TreatmentPlanUpdate from './treatment-plan-update';
import TreatmentPlanDeleteDialog from './treatment-plan-delete-dialog';

const TreatmentPlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentPlan />} />
    <Route path="new" element={<TreatmentPlanUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentPlanDetail />} />
      <Route path="edit" element={<TreatmentPlanUpdate />} />
      <Route path="delete" element={<TreatmentPlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentPlanRoutes;
